/**
 * @generated SignedSource<<ea18bd11a7f839235c781f250ead1c7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ScreenersParticipantRsvpChoices = "ACCEPTED" | "DECLINED" | "NEEDSACTION" | "TENTATIVE" | "%future added value";
export type ScreenersRespondentMasterStatusChoices = "A" | "CS" | "D" | "IW" | "NR" | "NS" | "OQ" | "RT" | "RW" | "S" | "SS" | "T" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ScheduleCell_respondent$data = {
  readonly dId: any | null;
  readonly id: string;
  readonly masterStatus: ScreenersRespondentMasterStatusChoices | null;
  readonly participant: {
    readonly rsvp: ScreenersParticipantRsvpChoices;
  } | null;
  readonly scheduledSlots: ReadonlyArray<{
    readonly end: any;
    readonly interviewed: boolean;
    readonly session: {
      readonly name: string;
    } | null;
    readonly start: any;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleModal_respondent">;
  readonly " $fragmentType": "ScheduleCell_respondent";
};
export type ScheduleCell_respondent$key = {
  readonly " $data"?: ScheduleCell_respondent$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleCell_respondent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScheduleCell_respondent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipantNode",
      "kind": "LinkedField",
      "name": "participant",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rsvp",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RespondentScheduledSlotNode",
      "kind": "LinkedField",
      "name": "scheduledSlots",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StudySessionNode",
          "kind": "LinkedField",
          "name": "session",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "interviewed",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleModal_respondent"
    }
  ],
  "type": "RespondentNode",
  "abstractKey": null
};

(node as any).hash = "7f04940ddc94839eee481e69413bae7c";

export default node;
